
export default {
  name: 'DealListItem',
  props: {
    deal: Object,
  },
}
